import {
    MOLD_DESIGN_IN_PROGRESS,
    MOLD_FABRICATION_IN_PROGRESS,
    MOLD_COMPLETE_TRAILING_IN_PROGRESS,
    MOLD_READY_FOR_PRODUCTION,
    PART_PRODUCTION_COMPLETE,
} from '@Orders/constants'

// Using an object cannot have null as key, Maps can.
export const moldOrderSteps = new Map()
moldOrderSteps.set(MOLD_DESIGN_IN_PROGRESS.toLowerCase(), {
    steps: [
        'Pending final design',
        'Tooling production',
        'Sample approval',
        'Part production',
    ],
    tooltip:
        'Once the DFM report is discussed, it is your responsibility to raise any questions and make design revisions. This process can take from a day to 2 weeks depending on the design complexity and customer availability.',
    selectedStep: 'Pending final design',
})
moldOrderSteps.set(MOLD_FABRICATION_IN_PROGRESS.toLowerCase(), {
    steps: [
        'Final design approved',
        'Tooling in progress',
        'Sample approval',
        'Part production',
    ],
    tooltip:
        'Once finalized design is received, Fictiv will procure steel, build the tool and make T sample shots.',
    selectedStep: 'Tooling in progress',
})
moldOrderSteps.set(MOLD_COMPLETE_TRAILING_IN_PROGRESS.toLowerCase(), {
    steps: [
        'Final design approved',
        'Tooling complete',
        'Pending sample approval',
        'Part production',
    ],
    tooltip:
        'Once T samples are shipped, it is your responsibility to approve or initiate any change requests. If changes to the tool are needed, Fictiv will send new T samples for your approval.',
    selectedStep: 'Pending sample approval',
})
moldOrderSteps.set(MOLD_READY_FOR_PRODUCTION.toLowerCase(), {
    steps: [
        'Final design approved',
        'Tooling complete',
        'Samples approved',
        'Part production in progress',
    ],
    tooltip:
        'Once the T samples are approved, parts production starts and you will receive shipments based on your desired delivery schedule.',
    selectedStep: 'Part production in progress',
})
moldOrderSteps.set(PART_PRODUCTION_COMPLETE.toLowerCase(), {
    steps: [
        'Final design approved',
        'Tooling complete',
        'Samples approved',
        'Part production complete',
    ],
    tooltip: '',
    selectedStep: '',
})

export const partRelatedSteps = [
    'Part production',
    'Part production in progress',
    'Part production complete',
]
